// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"tooltip__tooltip___L2wSh","tooltipActive":"tooltip__tooltip--active___1dGmW tooltip__tooltip___L2wSh"};


//////////////////
// WEBPACK FOOTER
// ./js/components/tooltip/tooltip.scss
// module id = 193
// module chunks = 0 1